import * as category from '@wix/auto_sdk_faq_category';
import * as questionEntry from '@wix/auto_sdk_faq_question-entry';

export { category, questionEntry };
